import type { LegendProps } from '../../core/types/legend.js';

/**
 * Props of the Honeycomb Legend
 * @public
 */
export type HoneycombLegendProps = LegendProps;

/**
 * @public
 */
export const HoneycombLegend = (props: HoneycombLegendProps) => null;
